/*
 * GF event - progressione tier, invito all'omaggio e badge di ammissibilita'.
 * 28/08/2026. Rivisto il 16/09/2026 tre volte: scala a etichette, numero fermo, tempi di
 * reazione. Poi ancora il 16/09 sera: il conteggio bloccato sul puntino di attesa.
 * Nessuna dipendenza. Nessuna aritmetica e nessuna regola di ammissibilita' qui dentro:
 * entrambe le cose le decide il server, questo file le trasporta e le disegna.
 *
 * DUE SORGENTI, ENTRAMBE SERVER, ENTRAMBE SUL PERCORSO CORRENTE
 *   <percorso>?section_id=gf-event-progress -> testo della progressione, piu' URL ed
 *                                             etichetta del pulsante omaggio quando ci sono.
 *   <percorso>?section_id=gf-promo-scope    -> quali prodotti della pagina sono in promo.
 * Ogni chiamata passa da sectionUrl(), mai da un percorso scritto a mano: e' il bug del
 * 28/08 sera, quando '/' fisso rispondeva in inglese sopra a una pagina /it/ o /fr/.
 *
 * =======================================================================================
 * TRE DIFETTI TROVATI IN COLLAUDO IL 16/09, E COSA HANNO INSEGNATO
 *
 * 1) IL NUMERO FERMO DI UN PASSO. Con carrello a 107 EUR la striscia diceva "Anade 107",
 *    cioe' il residuo del carrello precedente. Tre cause: refresh() usciva senza
 *    riprogrammarsi quando Dawn stava rigenerando .drawer__inner e nessun host era nel DOM;
 *    ensureDrawerStrip() ricreava la striscia col testo vecchio e concludeva di non avere
 *    bisogno del server; e in mancanza di quello il testo veniva ripescato dal DOM di
 *    un'altra superficie, vecchio uguale.
 *    Rimedio: una GENERAZIONE DI CARRELLO. Ogni mutazione vera incrementa gen; una risposta
 *    che torna con una generazione superata viene scartata e sostituita da un nuovo giro.
 *    Finche' il testo e' 'stale' nessuno lo riesuma da nessuna parte.
 *
 * 2) IL NUMERO VECCHIO CHE RESTAVA 1,3 SECONDI. Il puntino di attesa partiva dall'aggancio
 *    su window.fetch, cioe' solo quando Dawn faceva davvero la chiamata - e Dawn accorpa i
 *    click sulla quantita'. Rimedio: un listener in CATTURA sui comandi di quantita' segna
 *    il testo come sporco nell'istante del click. Misurato: da 1.277 ms a 106 ms.
 *
 * 3) IL CONTEGGIO CHE SI BLOCCAVA SUL PUNTINO. Trovato da Emanuele: cambiando la quantita'
 *    sulla SCHEDA PRODOTTO, striscia e box PDP restavano su "..." per sempre. Riprodotto.
 *    Due cause, e la seconda e' la piu' istruttiva:
 *      a. il listener 'change' guardava `.quantity__input` SENZA controllare di essere nel
 *         carrello. La quantita' di una PDP non e' una modifica di carrello: sporcava il
 *         testo senza che nessuna chiamata di carrello seguisse.
 *      b. sporcare e ricalcolare erano la stessa azione. Se la prima avveniva e la seconda
 *         no, lo stato di attesa era TERMINALE: nessuno lo avrebbe piu' tolto.
 *    Rimedio doppio. Il controllo di contesto sistema il caso noto. Ma la lezione vera e'
 *    la (b), quindi le due azioni sono state separate - markDirty() e' cosmetico e non
 *    chiede niente al server, bump() e' la mutazione vera che invalida le risposte in volo -
 *    e sopra c'e' una GUARDIA A TEMPO: se dopo sei secondi il testo e' ancora sporco, un
 *    ricalcolo parte comunque. Cosi' l'attesa non puo' piu' essere definitiva, qualunque
 *    sia la causa, anche una che oggi non conosciamo.
 *
 * Perche' markDirty() NON chiede subito il ricalcolo: la richiesta partirebbe prima che il
 * carrello sia cambiato lato server e tornerebbe col valore di prima, che verrebbe dipinto
 * come fresco. Sarebbe il difetto numero 1 daccapo, con un'altra faccia.
 * =======================================================================================
 *
 * PRINCIPIO DI SICUREZZA - vale per il numero, per il badge e per il pulsante omaggio.
 * Durante una promo con claim di prezzo una informazione sbagliata e' esposizione Omnibus.
 * Se il ricalcolo fallisce la riga sparisce e il pulsante con lei. Il fallimento e' l'assenza.
 *
 * PERCORSI DI SOLA LINGUA (15/10/2026). Su /it, /fr, /de, /es, /el e sulla radice il
 * mercato e' 'gr' e il server non conosce il Paese del visitatore. Se la pagina porta
 * [data-gfev-geo-need], qui si legge il Paese dall'IP (/browsing_context_suggestions.json,
 * lo stesso servizio della barra legacy) e lo si scrive UNA volta nell'attributo di carrello
 * `_gf_geo`. Solo quando il carrello ha righe, per non creare carrelli vuoti. Le soglie e il
 * testo restano decisi dal server: qui si trasporta solo un codice Paese di due lettere.
 *
 * PULSANTE OMAGGIO. Il Buy X Get Y di Shopify non aggiunge mai da solo il prodotto in
 * regalo, e riserva l'unita' regalata fuori dalla spesa minima (vedi gf-event-prog.liquid).
 * URL ed etichetta arrivano dal server come attributi; qui si costruisce un <a> con href e
 * textContent, mai con innerHTML.
 */
(function () {
  'use strict';

  var HOST_SEL = '[data-gfev-prog-host]';
  var GIFT_HOST_SEL = '[data-gfev-prog-host],[data-gfev-gift-host]';
  var TEXT_SEL = '[data-gfev-prog]';
  var GIFT_SEL = '[data-gfev-gift]';
  var LEGACY_PDP_SEL = '.gf-ev-box__prog';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var CART_CTX = 'cart-drawer, cart-drawer-items, .cart-items, .cart-item, #main-cart-items';
  var WAIT = '…';
  var BADGE = 'gf-ev-badge';
  var WATCHDOG_MS = 6000;

  var busy = false, again = false, timer = null, wd = null;
  var scope = null, scopeBusy = false, scopeDirty = true;
  var lastText = null, lastGiftUrl = '', lastGiftLabel = '';
  var gen = 0, stale = true;
  var domTimer = null;

  function each(sel, fn, root) {
    var n = (root || document).querySelectorAll(sel);
    for (var i = 0; i < n.length; i++) fn(n[i]);
  }

  function sectionUrl(name) {
    var q = location.search;
    return location.pathname + (q ? q + '&' : '?') + 'section_id=' + name;
  }

  /* Guardia a tempo: uno stato di attesa non puo' essere definitivo. */
  function arm() {
    clearTimeout(wd);
    wd = setTimeout(function () { if (stale) schedule(); }, WATCHDOG_MS);
  }

  /* Cosmetico: il numero a schermo non vale piu'. Non chiede niente al server. */
  function markDirty() {
    stale = true;
    lastText = null;
    lastGiftUrl = '';
    lastGiftLabel = '';
    pending();
    arm();
  }

  /* Mutazione vera del carrello: invalida anche le risposte gia' in volo. */
  function bump() {
    gen++;
    markDirty();
  }

  /* ---------------- progressione ---------------- */

  function setGift(host, url, label) {
    var a = host.querySelector(GIFT_SEL);
    if (!url || !label) { if (a && a.parentNode) a.parentNode.removeChild(a); return; }
    if (!a) {
      a = document.createElement('a');
      a.className = 'gf-ev-gift';
      a.setAttribute('data-gfev-gift', '');
      host.appendChild(a);
    }
    if (a.getAttribute('href') !== url) a.setAttribute('href', url);
    if (a.textContent !== label) a.textContent = label;
  }

  function clearGift() {
    each(GIFT_SEL, function (a) { if (a.parentNode) a.parentNode.removeChild(a); });
  }

  function pending() {
    each(TEXT_SEL, function (e) { if (e.textContent !== WAIT) e.textContent = WAIT; });
    each(LEGACY_PDP_SEL, function (e) { if (e.textContent !== WAIT) e.textContent = WAIT; });
    each(HOST_SEL, function (e) { e.hidden = false; });
    clearGift();
  }

  function paint(txt, gurl, glabel) {
    lastText = txt;
    lastGiftUrl = gurl || '';
    lastGiftLabel = glabel || '';
    stale = false;
    clearTimeout(wd);
    each(TEXT_SEL, function (e) { e.textContent = txt; });
    each(LEGACY_PDP_SEL, function (e) { e.textContent = txt; });
    each(HOST_SEL, function (e) { e.hidden = txt === ''; });
    each(GIFT_HOST_SEL, function (e) {
      setGift(e, txt === '' ? '' : lastGiftUrl, txt === '' ? '' : lastGiftLabel);
    });
  }

  function fail() {
    lastText = '';
    lastGiftUrl = '';
    lastGiftLabel = '';
    stale = false;
    clearTimeout(wd);
    each(TEXT_SEL, function (e) { e.textContent = ''; });
    each(LEGACY_PDP_SEL, function (e) { e.textContent = ''; });
    each(HOST_SEL, function (e) { e.hidden = true; });
    clearGift();
  }

  function refresh() {
    if (busy) { again = true; return; }
    if (!stale && !document.querySelector(GIFT_HOST_SEL) && !document.querySelector(LEGACY_PDP_SEL)) return;
    busy = true;
    var myGen = gen;
    try {
      fetch(sectionUrl('gf-event-progress'), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw 0; return r.text(); })
        .then(function (html) {
          busy = false;
          if (myGen !== gen) { again = false; schedule(); return; }
          var d = document.createElement('div');
          d.innerHTML = html;
          var s = d.querySelector('[data-gfev-prog-src]');
          paint(
            s ? s.textContent.trim() : '',
            s ? (s.getAttribute('data-gfev-gift-url') || '') : '',
            s ? (s.getAttribute('data-gfev-gift-label') || '') : ''
          );
          if (again) { again = false; schedule(); }
        })
        .catch(function () { fail(); busy = false; again = false; });
    } catch (e) { fail(); busy = false; again = false; }
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 150); }

  /* ---------------- ambito e badge ---------------- */

  function handleOf(el) {
    var a = el.querySelector('a[href*="/products/"]');
    if (!a) return null;
    try {
      var p = a.pathname.split('/products/')[1];
      return p ? p.split('?')[0].replace(/\/$/, '') : null;
    } catch (e) { return null; }
  }

  function scopeFetch(then) {
    if (scopeBusy) return;
    if (scope && !scopeDirty) { if (then) then(); return; }
    scopeBusy = true;
    fetch(sectionUrl('gf-promo-scope'), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var s = d.querySelector('[data-gfev-scope]');
        if (!s) { scope = null; }
        else {
          var raw = s.querySelector('[data-gfev-scope-list]');
          var list = (raw ? raw.textContent : '').trim().split(/\s+/);
          var set = {};
          for (var i = 0; i < list.length; i++) if (list[i]) set[list[i]] = 1;
          scope = {
            label: s.getAttribute('data-gfev-label') || '',
            promoCollection: s.getAttribute('data-gfev-promo-collection') === '1',
            set: set
          };
        }
        scopeBusy = false;
        scopeDirty = false;
        if (then) then();
      })
      .catch(function () { scopeBusy = false; });
  }

  function make(inline) {
    var b = document.createElement('span');
    b.className = inline ? BADGE + ' ' + BADGE + '--inline' : BADGE;
    b.textContent = scope.label;
    return b;
  }

  function putOnImage(container, measure) {
    if (!container) return false;
    var b = make(false);
    container.appendChild(b);
    var img = container.querySelector('img');
    var w = img && img.offsetWidth ? img.offsetWidth : container.clientWidth;
    if (w > 0 && b.offsetWidth > w - 8) { container.removeChild(b); return false; }
    if (measure && img) {
      var bottom = img.offsetTop + img.offsetHeight;
      if (bottom > 0 && bottom < container.offsetHeight) {
        b.style.bottom = 'auto';
        b.style.top = Math.max(0, bottom - b.offsetHeight - 4) + 'px';
      }
    }
    return true;
  }

  function putInline(row) {
    var anchor = row.querySelector('.cart-item__name')
      || row.querySelector('.card__heading a')
      || row.querySelector('a[href*="/products/"]');
    if (!anchor || !anchor.parentElement) return;
    anchor.insertAdjacentElement('afterend', make(true));
  }

  function applyBadges() {
    if (!scope || !scope.label) return;

    if (!scope.promoCollection) {
      each('.card-wrapper', function (c) {
        if (c.querySelector('.' + BADGE)) return;
        var h = handleOf(c);
        if (!h || !scope.set[h]) return;
        if (!putOnImage(c.querySelector('.card__media'), false)) putInline(c);
      });
    }

    each('.cart-item', function (r) {
      if (r.querySelector('.' + BADGE)) return;
      var h = handleOf(r);
      if (!h || !scope.set[h]) return;
      var std = r.querySelector('.cart-item__image-container');
      var media = std || r.querySelector('.cart-item__media');
      var img = media ? media.querySelector('img') : null;
      var done = false;
      if (media && img && img.offsetWidth > 20) done = putOnImage(media, !std);
      if (!done) putInline(r);
    });
  }

  function ensureDrawerStrip() {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (!inner || inner.querySelector(HOST_SEL)) return false;
    var items = inner.querySelector('cart-drawer-items');
    if (!items || !items.querySelector('.cart-item')) return false;

    var known = null;
    if (!stale) {
      known = lastText;
      if (known === null) {
        each(TEXT_SEL, function (e) {
          var t = e.textContent.trim();
          if (t && t !== WAIT && known === null) known = t;
        });
      }
    }

    var host = document.createElement('div');
    host.className = 'gf-ev-prog gf-ev-prog--drawer';
    host.setAttribute('data-gfev-prog-host', '');
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    host.hidden = !stale && !known;

    var dot = document.createElement('span');
    dot.className = 'gf-ev-prog__dot';
    dot.setAttribute('aria-hidden', 'true');
    var span = document.createElement('span');
    span.setAttribute('data-gfev-prog', '');
    span.textContent = stale ? WAIT : (known || '');
    host.appendChild(dot);
    host.appendChild(span);
    if (!stale && known && lastGiftUrl && lastGiftLabel) setGift(host, lastGiftUrl, lastGiftLabel);

    inner.insertBefore(host, items);
    return stale || known === null;
  }

  function redraw() {
    var serve = ensureDrawerStrip();
    applyBadges();
    if (serve) schedule();
  }

  function invalidate() {
    if (!stale) bump();
    scopeDirty = true;
    redraw();
    schedule();
    scopeFetch(applyBadges);
  }

  /* ---------------- Paese dall'IP, solo percorsi di sola lingua ---------------- */

  var GEO_KEY = 'gf_geo_v1';
  var geoState = 0; /* 0 da fare, 1 in corso, 2 fatto */

  function geoMarker() { return document.querySelector('[data-gfev-geo-need]'); }

  function geoSave(code) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: { _gf_geo: code } })
    });
  }

  function geoBoot(hasItems) {
    if (geoState !== 0 || !hasItems || !geoMarker()) return;
    geoState = 1;
    var cached = null;
    try { cached = sessionStorage.getItem(GEO_KEY); } catch (e) {}
    var p = cached ? Promise.resolve(cached)
      : fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (j) {
            var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
            return c ? String(c).toUpperCase() : null;
          });
    p.then(function (code) {
      if (!code || !/^[A-Z]{2}$/.test(code)) throw 0;
      try { sessionStorage.setItem(GEO_KEY, code); } catch (e) {}
      return geoSave(code);
    }).then(function () { geoState = 2; }, function () { geoState = 2; });
  }

  /* ---------------- osservazione, in sola lettura ---------------- */

  /* Solo i comandi di quantita' DENTRO il carrello. La quantita' di una scheda prodotto non
     e' una modifica di carrello: e' il difetto 3a. */
  function inCart(el) { return !!(el && el.closest && el.closest(CART_CTX)); }
  function isCartQtyControl(el) {
    if (!inCart(el)) return false;
    var b = el.closest('button, a');
    if (!b) return false;
    var n = b.getAttribute('name') || '';
    if (n === 'plus' || n === 'minus') return true;
    if (b.classList && b.classList.contains('quantity__button')) return true;
    if (b.classList && b.classList.contains('cart-remove-button')) return true;
    if ((b.id || '').indexOf('Remove-') === 0) return true;
    return false;
  }
  try {
    document.addEventListener('click', function (e) {
      if (isCartQtyControl(e.target)) markDirty();
    }, true);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (!t.matches('input[name="updates[]"], .quantity__input')) return;
      if (!inCart(t)) return;
      markDirty();
    }, true);
  } catch (e) {}

  try {
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function () {
        var hit = false;
        try {
          var a = arguments[0];
          hit = CART_RE.test(a && a.url ? a.url : String(a));
        } catch (e) {}
        if (hit) { bump(); scopeDirty = true; }
        var p = of.apply(this, arguments);
        if (hit) p.then(function () { redraw(); schedule(); scopeFetch(applyBadges); geoBoot(true); }, function () { schedule(); });
        return p;
      };
    }
  } catch (e) {}

  try {
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try {
        if (CART_RE.test(String(u))) {
          this.addEventListener('loadstart', function () { bump(); scopeDirty = true; });
          this.addEventListener('loadend', invalidate);
        }
      } catch (e) {}
      return oo.apply(this, arguments);
    };
  } catch (e) {}

  ['cart:update', 'cart:refresh', 'shopify:cart:update'].forEach(function (ev) {
    document.addEventListener(ev, invalidate);
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) invalidate(); });

  try {
    new MutationObserver(function () {
      clearTimeout(domTimer);
      domTimer = setTimeout(redraw, 150);
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  scopeFetch(redraw);

  (function () {
    var m = geoMarker();
    if (m && parseInt(m.getAttribute('data-items') || '0', 10) > 0) geoBoot(true);
  })();
})();
